module.exports = __webpack_public_path__ + "static/media/Banner inicial_imagen.63280117.png";